import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountViewDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountViewDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountViewDTO.translate = translateService;
}
this.Data = [];
this.CashAccounts = [];
this.Cashiers = [];
this.CashAccountTotals = [];
this.ToTransferForPeriod = [];
this.ToTransfer = [];
this.PreviousPeriodAmount = [];
this.DateFrom = null;
this.DateTo = null;
this.ToTransferTotal = null;
this.CashAccountViewDTOKey = null;
this._key = this.CashAccountViewDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
ToTransferTotal:any;
Data:any;
CashAccounts:any;
Cashiers:any;
CashAccountTotals:any;
ToTransferForPeriod:any;
ToTransfer:any;
PreviousPeriodAmount:any;
private _CashAccountViewDTOKey:any;
get CashAccountViewDTOKey(): any {
    return this._CashAccountViewDTOKey;
  }
set CashAccountViewDTOKey(value: any) {
    this._CashAccountViewDTOKey = value;
    this._key = value;
  }
static setData = ($this, items) => {
                if (items == null) items = [];
                if ($this.Data == null) $this.Data = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Data.length > 0) {
                    Domain.CashAccountViewDTO.removeData($this, $this.Data[0]);
                }

                Domain.CashAccountViewDTO.addManyData($this, copyItems);
            }
static addManyData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addData($this, items[i]);
                }
            }
static addData = ($this, item) => {
                if ($this.Data == null) $this.Data = [];
                if (item == null || $this.Data.indexOf(item) > -1) return;
                $this.Data.push(item);
}
static addRangeData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addData($this, item));
            }
static removeData = ($this, item) => {
                if ($this == null || $this.Data == null || $this.Data.indexOf(item) === -1) return;
                var _index = $this.Data.indexOf(item);
                $this.Data.splice(_index, 1);
}
static clearData = ($this) => { $this.Data = null; }
static setCashAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.CashAccounts == null) $this.CashAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CashAccounts.length > 0) {
                    Domain.CashAccountViewDTO.removeCashAccounts($this, $this.CashAccounts[0]);
                }

                Domain.CashAccountViewDTO.addManyCashAccounts($this, copyItems);
            }
static addManyCashAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addCashAccounts($this, items[i]);
                }
            }
static addCashAccounts = ($this, item) => {
                if ($this.CashAccounts == null) $this.CashAccounts = [];
                if (item == null || $this.CashAccounts.indexOf(item) > -1) return;
                $this.CashAccounts.push(item);
}
static addRangeCashAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addCashAccounts($this, item));
            }
static removeCashAccounts = ($this, item) => {
                if ($this == null || $this.CashAccounts == null || $this.CashAccounts.indexOf(item) === -1) return;
                var _index = $this.CashAccounts.indexOf(item);
                $this.CashAccounts.splice(_index, 1);
}
static clearCashAccounts = ($this) => { $this.CashAccounts = null; }
static setCashiers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Cashiers == null) $this.Cashiers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Cashiers.length > 0) {
                    Domain.CashAccountViewDTO.removeCashiers($this, $this.Cashiers[0]);
                }

                Domain.CashAccountViewDTO.addManyCashiers($this, copyItems);
            }
static addManyCashiers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addCashiers($this, items[i]);
                }
            }
static addCashiers = ($this, item) => {
                if ($this.Cashiers == null) $this.Cashiers = [];
                if (item == null || $this.Cashiers.indexOf(item) > -1) return;
                $this.Cashiers.push(item);
}
static addRangeCashiers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addCashiers($this, item));
            }
static removeCashiers = ($this, item) => {
                if ($this == null || $this.Cashiers == null || $this.Cashiers.indexOf(item) === -1) return;
                var _index = $this.Cashiers.indexOf(item);
                $this.Cashiers.splice(_index, 1);
}
static clearCashiers = ($this) => { $this.Cashiers = null; }
static setCashAccountTotals = ($this, items) => {
                if (items == null) items = [];
                if ($this.CashAccountTotals == null) $this.CashAccountTotals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CashAccountTotals.length > 0) {
                    Domain.CashAccountViewDTO.removeCashAccountTotals($this, $this.CashAccountTotals[0]);
                }

                Domain.CashAccountViewDTO.addManyCashAccountTotals($this, copyItems);
            }
static addManyCashAccountTotals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addCashAccountTotals($this, items[i]);
                }
            }
static addCashAccountTotals = ($this, item) => {
                if ($this.CashAccountTotals == null) $this.CashAccountTotals = [];
                if (item == null || $this.CashAccountTotals.indexOf(item) > -1) return;
                $this.CashAccountTotals.push(item);
}
static addRangeCashAccountTotals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addCashAccountTotals($this, item));
            }
static removeCashAccountTotals = ($this, item) => {
                if ($this == null || $this.CashAccountTotals == null || $this.CashAccountTotals.indexOf(item) === -1) return;
                var _index = $this.CashAccountTotals.indexOf(item);
                $this.CashAccountTotals.splice(_index, 1);
}
static clearCashAccountTotals = ($this) => { $this.CashAccountTotals = null; }
static setToTransferForPeriod = ($this, items) => {
                if (items == null) items = [];
                if ($this.ToTransferForPeriod == null) $this.ToTransferForPeriod = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ToTransferForPeriod.length > 0) {
                    Domain.CashAccountViewDTO.removeToTransferForPeriod($this, $this.ToTransferForPeriod[0]);
                }

                Domain.CashAccountViewDTO.addManyToTransferForPeriod($this, copyItems);
            }
static addManyToTransferForPeriod = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addToTransferForPeriod($this, items[i]);
                }
            }
static addToTransferForPeriod = ($this, item) => {
                if ($this.ToTransferForPeriod == null) $this.ToTransferForPeriod = [];
                if (item == null || $this.ToTransferForPeriod.indexOf(item) > -1) return;
                $this.ToTransferForPeriod.push(item);
}
static addRangeToTransferForPeriod = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addToTransferForPeriod($this, item));
            }
static removeToTransferForPeriod = ($this, item) => {
                if ($this == null || $this.ToTransferForPeriod == null || $this.ToTransferForPeriod.indexOf(item) === -1) return;
                var _index = $this.ToTransferForPeriod.indexOf(item);
                $this.ToTransferForPeriod.splice(_index, 1);
}
static clearToTransferForPeriod = ($this) => { $this.ToTransferForPeriod = null; }
static setToTransfer = ($this, items) => {
                if (items == null) items = [];
                if ($this.ToTransfer == null) $this.ToTransfer = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ToTransfer.length > 0) {
                    Domain.CashAccountViewDTO.removeToTransfer($this, $this.ToTransfer[0]);
                }

                Domain.CashAccountViewDTO.addManyToTransfer($this, copyItems);
            }
static addManyToTransfer = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addToTransfer($this, items[i]);
                }
            }
static addToTransfer = ($this, item) => {
                if ($this.ToTransfer == null) $this.ToTransfer = [];
                if (item == null || $this.ToTransfer.indexOf(item) > -1) return;
                $this.ToTransfer.push(item);
}
static addRangeToTransfer = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addToTransfer($this, item));
            }
static removeToTransfer = ($this, item) => {
                if ($this == null || $this.ToTransfer == null || $this.ToTransfer.indexOf(item) === -1) return;
                var _index = $this.ToTransfer.indexOf(item);
                $this.ToTransfer.splice(_index, 1);
}
static clearToTransfer = ($this) => { $this.ToTransfer = null; }
static setPreviousPeriodAmount = ($this, items) => {
                if (items == null) items = [];
                if ($this.PreviousPeriodAmount == null) $this.PreviousPeriodAmount = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PreviousPeriodAmount.length > 0) {
                    Domain.CashAccountViewDTO.removePreviousPeriodAmount($this, $this.PreviousPeriodAmount[0]);
                }

                Domain.CashAccountViewDTO.addManyPreviousPeriodAmount($this, copyItems);
            }
static addManyPreviousPeriodAmount = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewDTO.addPreviousPeriodAmount($this, items[i]);
                }
            }
static addPreviousPeriodAmount = ($this, item) => {
                if ($this.PreviousPeriodAmount == null) $this.PreviousPeriodAmount = [];
                if (item == null || $this.PreviousPeriodAmount.indexOf(item) > -1) return;
                $this.PreviousPeriodAmount.push(item);
}
static addRangePreviousPeriodAmount = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewDTO.addPreviousPeriodAmount($this, item));
            }
static removePreviousPeriodAmount = ($this, item) => {
                if ($this == null || $this.PreviousPeriodAmount == null || $this.PreviousPeriodAmount.indexOf(item) === -1) return;
                var _index = $this.PreviousPeriodAmount.indexOf(item);
                $this.PreviousPeriodAmount.splice(_index, 1);
}
static clearPreviousPeriodAmount = ($this) => { $this.PreviousPeriodAmount = null; }

static GetTableColumns($this: any): any{let cols = [];
let dateCol = new Domain.TableColumnDTO();
dateCol.field = "Date";
dateCol.header = "Ημερομηνία";
dateCol.type = "date";
cols?.add(dateCol);
let descriptionCol = new Domain.TableColumnDTO();
descriptionCol.field = "Description";
descriptionCol.header = "Περιγραφή";
descriptionCol.type = "string";
cols?.add(descriptionCol);
let aaCol = new Domain.TableColumnDTO();
aaCol.field = "AA";
aaCol.header = "ΑΑ";
aaCol.type = "number";
cols?.add(aaCol);
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => $this.CashAccounts.length); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let cashAccount = $this?.CashAccounts[i];let debitCol = new Domain.TableColumnDTO();debitCol.index = i;debitCol.field = "Debit";debitCol.header = CLMS.Framework.String.Format("Χρέωση {0}", cashAccount?.Name);debitCol.type = "amount";cols?.add(debitCol);let creditCol = new Domain.TableColumnDTO();creditCol.index = i;creditCol.field = "Credit";creditCol.header = CLMS.Framework.String.Format("Πίστωση {0}", cashAccount?.Name);creditCol.type = "amount";cols?.add(creditCol);}

return cols;
}
static Update(cashAccounts: any,cashAccount: any,item: any,isIncome: any,paymentType: any,amount: any,increaseAA: any): any{for (let _icAccount = 0; _icAccount < (cashAccounts == null ? 0 : cashAccounts.length); _icAccount++) {let cAccount = cashAccounts[_icAccount];if (item?.CashAccounts?.linq?.any((a) => a?.CashAccount == cAccount)) {continue;}let cAccountViewDetail = new Domain.CashAccountViewDetailDTO();Domain.CashAccountViewDetailDTO.setCashAccount(cAccountViewDetail, cAccount);cAccountViewDetail.Debit = 0;cAccountViewDetail.Credit = 0;cAccountViewDetail.AA = 0;item?.CashAccounts?.add(cAccountViewDetail);}
let cashAccountViewDetail = item?.CashAccounts?.linq?.where((a) => a?.CashAccount == cashAccount)?.firstOrDefault(null);
if (cashAccountViewDetail == null) {return item;}
if (increaseAA) {item.AA = Joove.Common.safeNumber(item?.AA) + Joove.Common.safeNumber(1);cashAccountViewDetail.AA = Joove.Common.safeNumber(cashAccountViewDetail?.AA) + Joove.Common.safeNumber(1);}
if (isIncome) {cashAccountViewDetail.Debit = Joove.Common.safeNumber(cashAccountViewDetail?.Debit) + Joove.Common.safeNumber(amount);}else {cashAccountViewDetail.Credit = Joove.Common.safeNumber(cashAccountViewDetail?.Credit) + Joove.Common.safeNumber(amount);}
return item;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountViewDTOKey == null || $this.CashAccountViewDTOKey == 0;
            }


}